export default __webpack_public_path__ + "static/brand_portal_bg_bottom_nav-974d610d0849334a9204414344508ad2.jpg";